var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/employment"}},[_vm._v("従業員設定")])}
var staticRenderFns = []

export { render, staticRenderFns }